(function () {
  let scrollToTopWrp = null;
  let scrollToTopBtn = null;
  let scrollAnimation = null;
  let wheelHandler = null;
  let scrollHandler = null;
  /* perf: sentinel + IntersectionObserver replace scroll-event reads of scrollTop/innerHeight */
  let sentinel = null;
  let sentinelObserver = null;

  function showScrollToTop() {
    if (document.body.scrollTop > window.innerHeight / 2 || document.documentElement.scrollTop > window.innerHeight / 2) {
      scrollToTopWrp?.classList.add('active');
    } else {
      scrollToTopWrp?.classList.remove('active');
    }
  }

  function scrollToTop() {
    const position = document.body.scrollTop || document.documentElement.scrollTop;

    if (scrollAnimation) {
      clearTimeout(scrollAnimation);
      scrollAnimation = null;
    }

    if (wheelHandler) {
      window.removeEventListener('wheel', wheelHandler);
      wheelHandler = null;
    }

    if (position) {
      window.scrollBy(0, -Math.max(1, Math.floor(position / 10)));
      scrollAnimation = setTimeout(scrollToTop, 30);

      wheelHandler = () => {
        if (scrollAnimation) {
          clearTimeout(scrollAnimation);
          scrollAnimation = null;
        }
        window.removeEventListener('wheel', wheelHandler);
        wheelHandler = null;
      };

      window.addEventListener('wheel', wheelHandler);
    }
  }

  function cleanupScrollToTop() {
    if (scrollAnimation) {
      clearTimeout(scrollAnimation);
      scrollAnimation = null;
    }
    if (wheelHandler) {
      window.removeEventListener('wheel', wheelHandler);
      wheelHandler = null;
    }
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    /* perf: tear down observer + sentinel */
    if (sentinelObserver) {
      sentinelObserver.disconnect();
      sentinelObserver = null;
    }
    if (sentinel) {
      sentinel.remove();
      sentinel = null;
    }
    if (scrollToTopBtn) {
      scrollToTopBtn.removeEventListener('click', onScrollToTopClick);
    }
    scrollToTopWrp = null;
    scrollToTopBtn = null;
  }

  function onScrollToTopClick() {
    scrollToTop();
  }

  function initScrollToTop() {
    cleanupScrollToTop();

    scrollToTopWrp = document.querySelector('.scroll-to-top');
    scrollToTopBtn = scrollToTopWrp?.querySelector('.scrollToTop');

    if (!scrollToTopWrp) return;

    /* perf: button is active once the top half-viewport sentinel has scrolled out of view */
    if ('IntersectionObserver' in window) {
      sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:50vh;pointer-events:none;visibility:hidden;';
      document.body.appendChild(sentinel);
      sentinelObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        scrollToTopWrp?.classList.toggle('active', !entry.isIntersecting);
      });
      sentinelObserver.observe(sentinel);
    } else {
      scrollHandler = () => {
        showScrollToTop();
      };

      window.addEventListener('scroll', scrollHandler, { passive: true });
      showScrollToTop();
    }

    if (scrollToTopBtn) {
      scrollToTopBtn.addEventListener('click', onScrollToTopClick);
    }
  }

  window.cleanupScrollToTop = cleanupScrollToTop;

  document.addEventListener('DOMContentLoaded', initScrollToTop);
  document.addEventListener('shopify:section:load', initScrollToTop);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('scroll-to-top')) {
      cleanupScrollToTop();
    }
  });
})();